import { useState } from "react";
import ApiFetch from "../../services/api.fetch";
import { URLS } from "../../utils/url";

export const useSubmitScreening = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({
    message: "",
    status: false,
  });

  const submit = async (candidateId: number) => {
    try {
      setLoading(true);
      const payload = {
        candidateId: candidateId,
        submitted: true,
      };
      const result = await ApiFetch.httpPost(
        URLS.post.tenant.updateCandidate,
        payload,
      );
      setData(result);
      return result;
    } catch (error) {
      setError({
        message: "Something went wrong",
        status: true,
      });
    } finally {
      setLoading(false);
    }
  };

  const values: any = {
    loading,
    error,
    data,
    submit,
  };
  return values;
};
